svg.icon {
  width: 14px;
  height: 14px;
  vertical-align: -3px;
}

.explanation {
  cursor: help;
  margin-left: 5px;
}
